import React from 'react'
import Image from 'next/image'
import styles from './smallOptionCard.module.scss'

interface SmallOptionCardProps {
  data: {
    optionCardName?: string
    optionCardHeading?: string
    optionCardSubHeading?: string
    icon?: {
      data?: {
        attributes?: {
          url: string
          width?: number
          height?: number
        }
      }
    }
    value?: string
  }
  selected?: boolean
  onClick?: () => void
}

const SmallOptionCard = ({ data, selected, onClick }: SmallOptionCardProps) => {
  const { optionCardHeading, optionCardSubHeading, icon, optionCardName, value } = data

  return (
    <div
      className={`${styles.cardContainer} ${selected ? styles.selected : ''}`}
      data-value={value}
      data-name={optionCardName}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}>
      {icon?.data?.attributes?.url && (
        <div className={styles.iconWrapper}>
          <Image
            src={icon.data.attributes.url}
            alt={optionCardHeading || optionCardName || 'Option card icon'}
            width={icon.data.attributes.width || 40}
            height={icon.data.attributes.height || 40}
            className={styles.icon}
            loading="lazy"
          />
        </div>
      )}
      <div className={styles.cardContent}>
        {optionCardHeading && (
          <div className={optionCardSubHeading ? styles.headingSecondary : styles.heading}>{optionCardHeading}</div>
        )}
        {optionCardSubHeading && <div className={styles.subHeading}>{optionCardSubHeading}</div>}
      </div>
    </div>
  )
}

export default SmallOptionCard
